import React, { useRef, useEffect } from 'react';
import { withLocale } from '../../../../utils/hocs';

const DATA_TEMPLATE_ID = '53aa8807dec7e10d38f59f32';
const DATA_BUSINESSUNIT_ID = '5742f9ec0000ff00058d3fa1';

export const TrustpilotMiniReviews = withLocale(({ locale }) => {
  const TrustpilotRef = useRef(null);
  const lightLocale = locale[0].slice(0, 2);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Trustpilot) {
      window.Trustpilot.loadFromElement(TrustpilotRef.current);
    }
  }, []);

  return (
    <div
      className='trustpilot-widget'
      data-locale={locale[0]}
      data-style-width='200px'
      data-template-id={DATA_TEMPLATE_ID}
      data-businessunit-id={DATA_BUSINESSUNIT_ID}
      data-theme='light'
      data-stars='4,5'
      ref={TrustpilotRef}>
      <a
        href={`https://${lightLocale}.trustpilot.com/review/nooz-optics.com`}
        target='_blank'
        rel='noopener noreferrer'
      />
    </div>
  );
});
